<template>
  <div
    v-if="visible"
    class="modal-overlay"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1050; display: flex; align-items: center; justify-content: center;"
    @click.self="$emit('close')">
    <div
      role="dialog"
      class="account-restricted-modal"
      style="pointer-events: auto; max-width: 30rem; width: 92%; background: white; border-radius: 0.75rem; padding: 0; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);">
      <div style="display: flex; align-items: center; gap: 0.5rem; padding: 1.5rem 1.5rem 0.75rem 1.5rem;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0; color: #111827;">Ação indisponível</h3>
      </div>
      <div style="padding: 0.25rem 1.5rem 1.5rem 1.5rem;">
        <p style="margin: 0; font-size: 1rem; line-height: 1.5; color: #64748b;">
          {{ message }}
        </p>
        <div style="display: flex; justify-content: flex-end; margin-top: 1.25rem;">
          <button
            type="button"
            class="account-restricted-confirm-button"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; border-radius: 0.625rem; font-size: 0.9rem; font-weight: 500; height: 2.625rem; padding-left: 1.5rem; padding-right: 1.5rem; border: none; cursor: pointer;"
            @click="$emit('close')">
            Entendi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGES } from '@/utils/error-message'

export default {
  name: 'AccountRestrictedModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      message: MESSAGES.ACCOUNT_RESTRICTED.lines[0]
    }
  }
}
</script>

<style scoped>
.account-restricted-confirm-button {
  color: #ffffff;
  background: linear-gradient(90deg, #2563eb 0%, #1d4ed8 55%, #1e40af 100%);
  transition: opacity 0.2s ease;
}

.account-restricted-confirm-button:hover {
  opacity: 0.92;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/AccountRestrictedModal.vue